import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

const SideText = ({ content }) => {

    return (
        <div className={styles.sideText}>
            <div className={styles.sideTextScroll}>
                {content.map((item, index) => {
                        return (
                            <a key={index} href={item.url} target="_blank" className={styles.sideTextItem}>{item.title}</a>
                        );
                    })
                }
            </div>
        </div>
    );
};

SideText.propTypes = {
    content: PropTypes.array,
};

export default errorBoundary(SideText);
